export default {
  main: '#ffffff',
  secondary: '#CDDCAE',
  contrastingColor: '#000000',
  priceColor: '#CDDCAE',
  entryBackground: '#ffffff',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
